/*
 * em-sizechart-quickshop.js
 * --------------------------------------------------------------------------
 * Ella & Marie / Impulse theme.
 *
 * Adds the EXISTING "Größentabelle" size-chart popup (System B,
 * snippets/ella-size-chart-popup.liquid) to the Quick Shop / Quick View modal.
 *
 * Why it is missing there: Quick Shop loads /products/<handle>?view=modal and
 * injects the HTML with innerHTML. The size-chart markup (`[data-ella-sc]`
 * wrapper, the hidden `.ella-sc__link`, and the `.ella-sc__overlay` that already
 * contains this product's table + logo) and its `<style>` ARE injected and the
 * CSS applies -- but a <script> set via innerHTML never executes, so the inline
 * initialiser that un-hides/places the link and wires open/close never runs
 * (verified: window.__ellaSC stays false on collection/home pages).
 *
 * This asset is loaded normally in theme.liquid, so it runs. Per Quick Shop
 * holder it:
 *   - un-hides/clones the link into the Größe size-chart slot
 *     (`.swatch-label-container.size-chart-right`, same place as the PDP), or a
 *     Größe-fieldset fallback,
 *   - opens THAT product's existing overlay on click (targeted by the link's
 *     `aria-controls="ella-sc-<id>"`, so every product gets its own chart),
 *   - closes on X / outside / Esc.
 *
 * Reuses the existing modal + table + CSS (no duplicate modal, no new styling).
 * Scoped to `[id^=QuickShopHolder-]` only, so the product page popup is untouched
 * (PDPs have no Quick Shop holder, and this never sets window.__ellaSC). The link
 * is only ever present when the product has a size chart, because the snippet only
 * renders `[data-ella-sc]` when custom.size_chart_table is non-blank.
 * Re-places on a 50/150/300/600/1000ms burst + on swatch changes + via a
 * persistent observer, because SwatchKing rebuilds the size slot (and our fix
 * regenerates it) on open / colour change. De-dupes to a single link per holder.
 */
(function () {
  if (window.__ellaSCQuickShop) return;
  window.__ellaSCQuickShop = 1;

  var HOLDER_SEL = '[id^="QuickShopHolder-"]';
  var SLOT_SEL = '.swatch-label-container.size-chart-right, .size-chart-right';
  // mirrors ella-size-chart-popup.liquid shorten() so Quick Shop headers match the PDP
  var HMAP = { 'größe': 'Größe', 'grösse': 'Größe', 'grosse': 'Größe', 'size': 'Größe', 'brustumfang': 'Brust', 'brust': 'Brust', 'taillenumfang': 'Taille', 'taille': 'Taille', 'hüftumfang': 'Hüfte', 'hüfte': 'Hüfte', 'länge': 'Länge', 'ärmellänge': 'Ärmel', 'ärmel': 'Ärmel', 'schulterbreite': 'Schulter', 'schulter': 'Schulter' };
  function shortenTables(holder) {
    holder.querySelectorAll('.ella-sc__tw table').forEach(function (t) {
      if (t.__s) return;
      t.__s = 1;
      t.querySelectorAll('th').forEach(function (th) {
        var raw = th.textContent.replace(/\s*\(cm\)\s*/i, '').replace(/\s+/g, ' ').trim();
        th.textContent = HMAP[raw.toLowerCase()] || raw;
      });
    });
  }

  function inHolder(el) { return el && el.closest ? el.closest(HOLDER_SEL) : null; }

  function lock(on) {
    document.documentElement.classList.toggle('ella-sc-lock', on);
    document.body.classList.toggle('ella-sc-lock', on);
  }
  function openModal(m, trigger) {
    if (!m || !m.hidden) return;
    m.__t = trigger;
    m.hidden = false;
    void m.offsetWidth;            // reflow so the open transition runs
    m.classList.add('is-open');
    lock(true);
  }
  function closeModal(m) {
    if (!m || m.hidden) return;
    m.classList.remove('is-open');
    lock(false);
    window.setTimeout(function () { m.hidden = true; }, 220);
    if (m.__t) { try { m.__t.focus(); } catch (e) {} }
  }

  // The size-chart slot (Größe row) inside a holder; fallback to the Größe fieldset.
  function sizeSlot(holder) {
    var s = holder.querySelector(SLOT_SEL);
    if (s) return s;
    var legends = holder.querySelectorAll('legend, .swatch-option-name, .variant__label');
    for (var i = 0; i < legends.length; i++) {
      if (/Gr(ö|o|ö)?(ß|ss|s)e/i.test(legends[i].textContent || '')) {
        return legends[i].closest('fieldset, .variant-input-wrap, .variant-wrapper') || legends[i].parentElement;
      }
    }
    return null;
  }

  // Un-hide + place exactly one size-chart link near Größe inside a holder.
  function place(holder) {
    var wrap = holder.querySelector('[data-ella-sc]');
    if (!wrap) return;                                   // no size chart -> no link (req 4)
    shortenTables(holder);                               // match PDP popup headers
    var tplBtn = wrap.querySelector('.ella-sc__link');
    if (!tplBtn) return;
    var slot = sizeSlot(holder);
    if (!slot) return;                                   // size row not ready yet -> retry

    // de-dupe: keep at most one placed link in the slot
    var placed = slot.querySelectorAll('.ella-sc__link');
    for (var i = 1; i < placed.length; i++) placed[i].remove();

    // hide SwatchKing's empty size-chart placeholder so ours is the only one
    var ph = slot.querySelector('.swatch-size-chart');
    if (ph) ph.style.setProperty('display', 'none', 'important');

    var existing = slot.querySelector('.ella-sc__link');
    if (existing) {
      if (existing.hidden) existing.hidden = false;
      existing.style.marginLeft = 'auto';
      existing.style.cursor = 'pointer';
      return;
    }

    var btn = tplBtn.cloneNode(true);
    btn.removeAttribute('hidden');
    btn.hidden = false;
    btn.style.marginLeft = 'auto';
    btn.style.cursor = 'pointer';
    btn.setAttribute('data-ella-sc-qs', '1');
    // ensure it targets THIS product's overlay
    if (!btn.getAttribute('aria-controls')) {
      var ov = wrap.querySelector('[data-ella-sc-modal], .ella-sc__overlay');
      if (ov && ov.id) btn.setAttribute('aria-controls', ov.id);
    }
    slot.appendChild(btn);
  }

  // Wait until the holder's DOM has settled (SwatchKing + our swatch fix have
  // finished regenerating the swatches) before injecting the link. Injecting
  // while SwatchKing is mid-regeneration makes it duplicate the whole swatch
  // block, so we hold off until mutations stop, then place exactly once.
  function settleThenPlace(holder) {
    if (!holder || holder.__ellaScSettling) return;
    holder.__ellaScSettling = true;
    var idle = null, obs = null, done = false;
    function finish() {
      if (done) return;
      done = true;
      try { if (obs) obs.disconnect(); } catch (e) {}
      holder.__ellaScSettling = false;
      place(holder);
    }
    try {
      obs = new MutationObserver(function () {
        if (idle) clearTimeout(idle);
        idle = window.setTimeout(finish, 350);   // 350ms of quiet = settled
      });
      obs.observe(holder, { childList: true, subtree: true });
    } catch (e) {}
    idle = window.setTimeout(finish, 350);        // settle even if no mutations
    window.setTimeout(function () { if (!done) finish(); }, 4000); // hard cap
  }

  // ---- open / close (scoped to size-chart links/modals inside a Quick Shop holder)
  document.addEventListener('click', function (e) {
    var open = e.target.closest && e.target.closest('.ella-sc__link, [data-ella-sc-open]');
    if (open && inHolder(open) && !open.closest('[data-ella-sc-dialog]')) {
      e.preventDefault();
      e.stopImmediatePropagation();
      var id = open.getAttribute('aria-controls');
      var modal = (id && document.getElementById(id)) ||
        inHolder(open).querySelector('[data-ella-sc-modal], .ella-sc__overlay');
      openModal(modal, open);
      return;
    }
    var close = e.target.closest && e.target.closest('[data-ella-sc-close]');
    if (close && inHolder(close)) {
      e.preventDefault();
      closeModal(close.closest('[data-ella-sc-modal]'));
      return;
    }
    var ov = e.target.closest && e.target.closest('[data-ella-sc-modal]');
    if (ov && inHolder(ov) && !e.target.closest('[data-ella-sc-dialog]')) {
      closeModal(ov);
    }
  }, true);

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' || e.keyCode === 27) {
      var o = document.querySelector(HOLDER_SEL + ' [data-ella-sc-modal].is-open');
      if (o) closeModal(o);
    }
  });

  // ---- triggers: modal open, swatch change (SwatchKing rebuilds the size slot)
  document.addEventListener('click', function (e) {
    var t = e.target;
    var trigger = t.closest && t.closest('.quick-product__btn, [class*="js-modal-open-quick-modal"]');
    if (trigger) {
      var card = trigger.closest('.grid-product');
      var handle = card && card.dataset ? card.dataset.productHandle : null;
      var holder = handle ? document.getElementById('QuickShopHolder-' + handle) : null;
      if (holder) settleThenPlace(holder);   // place once SwatchKing has settled
      return;
    }
    // user changes a swatch -> SwatchKing rebuilds the size slot, wiping our link.
    // Route through settleThenPlace (NOT an immediate place): SwatchKing also
    // fires synthetic change events while it (re)generates, and injecting mid-
    // generation makes it duplicate the whole swatch block. settleThenPlace waits
    // for the DOM to go quiet first, then places exactly once.
    var sw = t.closest && t.closest('variant-swatch-king,.swatch-view-item,.swatch-label,.swatch-label-container,[data-variant-input],.variant-input');
    if (sw) { var h = inHolder(sw); if (h) settleThenPlace(h); }
  }, true);
  document.addEventListener('change', function (e) {
    var sw = e.target.closest && e.target.closest('variant-swatch-king,.variant-input-wrap,[data-variant-input]');
    if (sw) { var h = inHolder(sw); if (h) settleThenPlace(h); }
  }, true);

  // Resilience: when a holder's content changes (AJAX re-preload, reopen, or
  // SwatchKing rebuild), re-run settleThenPlace for it. This is SAFE because it
  // routes through settleThenPlace (waits for the DOM to go quiet, then places
  // once) -- it never injects mid-generation, so it can't make SwatchKing
  // duplicate. settleThenPlace's own guard + de-dupe keep it to one link.
  var rt = null;
  function start() {
    if (!document.body) return;
    try {
      new MutationObserver(function (muts) {
        for (var i = 0; i < muts.length; i++) {
          var h = inHolder(muts[i].target);
          if (h) {
            if (rt) clearTimeout(rt);
            rt = window.setTimeout(function () {
              document.querySelectorAll(HOLDER_SEL).forEach(settleThenPlace);
            }, 120);
            return;
          }
        }
      }).observe(document.body, { childList: true, subtree: true });
    } catch (e) {}
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
